var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('spinner-component',{attrs:{"loading":_vm.loading}}),_c('error-dialog-component',{attrs:{"model-value":this.errorDialog}}),(_vm.popupContent)?_c('edit-popup-content-view',{attrs:{"popup-content-prop":_vm.popupContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }